import { Skeleton } from "@/shared/components";

type SkeletonDossierCardProps = {
    testId?: string;
};
export function SkeletonDossierCard({ testId = "dossier-skeleton" }: SkeletonDossierCardProps) {
    return (
        <div
            className="border-default rounded-m flex max-h-[82px] min-h-[82px] w-[180px] flex-col gap-1 border px-3 py-2"
            title="Loading data..."
            data-testid={testId}
        >
            <div className="text-s leading-m text-content-emphasis flex w-full items-start justify-between font-medium">
                <Skeleton className="h-4 w-24" />
                <div className="flex items-center gap-2">
                    <Skeleton className="h-4 w-10" />
                </div>
            </div>
            <div className="text-s leading-m text-content-default flex w-full items-start justify-between gap-1">
                <Skeleton className="h-4 w-full" />
            </div>
            <div className="text-content-emphasis gap-xs flex">
                <Skeleton className="h-5 w-5" />
                <Skeleton className="h-5 w-5" />
                <Skeleton className="h-5 w-5" />
                <Skeleton className="h-5 w-5" />
            </div>
        </div>
    );
}
